/**
 * 
 */
Converia.Core.module('Converia.Invoice.PosStrategie', function () {
    /**
     * POS_MESSAGE_TYPES
     * 
     * @type {{WAITING: number, SUCCESS: number}}
     */
    var POS_MESSAGE_TYPES = {
        WAITING: -1,
        SUCCESS: 0
    };

    /**
     * POS_PAYMENT_ACTION
     * 
     * @type {{INIT: string, FAIL: string, SUCCESS: string}}
     */
    var POS_PAYMENT_ACTION = {
        INIT: 'INIT',
        FAIL: 'FAIL',
        SUCCESS: 'SUCCESS',
        FATAL: 'FATAL',
    };

    var pendingPOSPayment = false;
    var posMessageReceived = POS_MESSAGE_TYPES.WAITING;

    /**
     * PosStrategie
     * 
     * @param form
     * @param electronService
     * @constructor
     */
    var PosStrategie = function (form, electronService) {
        this.electronService = electronService;
        this.form = form;
        this.amount = 0;
        this.logUrl = $(form).data('cash-log-url');
    };

    /**
     * PosStrategie.prototype.handleBeforeSubmit
     * 
     * @returns {boolean}
     */
    PosStrategie.prototype.handleBeforeSubmit = function () {
        if (!this.electronService.inElectron()) {
            BEGUI.getInstance().pushMessage(BEGUI.MESSAGETYPE.ERROR, 'This payment kind can only be used in connection with the Converia Desktop App.');
            begui.processEnded();
            return false;
        }
        
        if (pendingPOSPayment) {
            BEGUI.getInstance().pushMessage(BEGUI.MESSAGETYPE.ERROR, 'Another payment is still pending, you can not trigger a second one.');
            return false;
        }
        
        var amountElement = this.form.elements.namedItem('amount');
        
        if (!amountElement) {
            BEGUI.getInstance().pushMessage(BEGUI.MESSAGETYPE.ERROR, 'Amount element not found.');
            return false;
        }
        
        // here we handle the actual form re-submission (from code) after we received the message from the terminal, the form submission we aborted before
        if (posMessageReceived === POS_MESSAGE_TYPES.SUCCESS) {
            posMessageReceived = POS_MESSAGE_TYPES.WAITING;
            return true;
        }
        
        BEGUI.getInstance().processEnded();
        BEGUI.getInstance().processStarted(true);
        
        this.amount = parseFloat(amountElement.value.replace(/,/, '.'));

        if (this.amount < 0.001) {
            BEGUI.getInstance().pushMessage(BEGUI.MESSAGETYPE.ERROR, 'Invalid amount.');
            BEGUI.Modal.instance.close();
            BEGUI.getInstance().processEnded();
            return false;
        }

        this.electronService.send('request-payment', {price: this.amount});
        this.electronService.send('nonclickable');
        pendingPOSPayment = true;

        this.electronService.removeAllListeners('payment-result');
        this.electronService.once('payment-result', $.proxy(this.onPaymentResult, this));
        this.logPaymentInfo(POS_PAYMENT_ACTION.INIT, {price: this.amount});

        // abort the form submission here because we initiated the process on the terminal
        return false;
    };

    /**
     * PosStrategie.prototype.logPaymentInfo
     * 
     * @param actionName
     * @param data
     */
    PosStrategie.prototype.logPaymentInfo = function (actionName, data) {
        var formData = new FormData();

        formData.append('paymentKey', 'POS');
        formData.append('actionName', actionName);
        formData.append('jsonData', JSON.stringify(data));
        fetch(
            this.logUrl,
            {
                method: 'POST',
                credentials: 'include',
                body: formData
            }
        ).then(function (response) {
            return response.json();
        }).then($.proxy(this.onLogSuccess, this));
    };

    /**
     * PosStrategie.prototype.onLogSuccess
     * 
     * @param jsonResponse
     */
    PosStrategie.prototype.onLogSuccess = function (jsonResponse) {
        //currently we can do much here, later we will keep a log reference for log connection here
    };

    /**
     * PosStrategie.prototype.onPaymentResult
     * 
     * @param event
     * @param result
     */
    PosStrategie.prototype.onPaymentResult = function (event, result) {
        pendingPOSPayment = false;
        BEGUI.getInstance().processEnded();
        try{
            if (result && result.result_code === POS_MESSAGE_TYPES.SUCCESS) {
                var amountElement = this.form.elements.namedItem('amount');
                var externalTransactionIdElement = this.form.elements.namedItem('externalTransactionId');
                var timestampElement = this.form.elements.namedItem('timestamp');
                var actualReceiptOfElement = this.form.elements.namedItem('actualReceiptOf');
                var referenceElement = this.form.elements.namedItem('ref_string');

                if (amountElement) {
                    amountElement.value = this.amount;//force value given to pos and ensure it is stored in converia
                }

                if (externalTransactionIdElement) {
                    externalTransactionIdElement.value = result.payment_id;
                }

                if (referenceElement) {
                    referenceElement.value = result.reference_number;
                }

                if (timestampElement) {
                    timestampElement.value = $.datepicker.formatDate("dd.mm.yy", new Date()); //force now
                }

                if (actualReceiptOfElement) {
                    actualReceiptOfElement.value = '';//pos payments are not confirmed yet
                }

                try {
                    posMessageReceived = POS_MESSAGE_TYPES.SUCCESS;
                    $(this.form).submit();
                    this.logPaymentInfo(POS_PAYMENT_ACTION.SUCCESS,{payment_id:result.payment_id,reference_number:result.reference_number});
                }catch (e) {
                    posMessageReceived = POS_MESSAGE_TYPES.FAIL;
                    this.logPaymentInfo(POS_PAYMENT_ACTION.FAIL,{raw_data:result, submit_error:e});
                }
                this.electronService.send('clickable');
            } else {
                this.logPaymentInfo(POS_PAYMENT_ACTION.FAIL, {raw_data: result});
                posMessageReceived = POS_MESSAGE_TYPES.WAITING;
                BEGUI.getInstance().pushMessage(BEGUI.MESSAGETYPE.ERROR, 'Payment on POS terminal failed, code: ' + result.result_code + ' ,message: ' + result.result_msg);
                this.electronService.send('clickable');
                BEGUI.Modal.instance.close(true);
            }
        } catch(e) {
            this.logPaymentInfo(POS_PAYMENT_ACTION.FATAL,{unexpected_exception:e});
        }
        
    };

    return PosStrategie;
});